export default __webpack_public_path__ + "static/media/silver_standard.e2aced02.svg";